import { buildEndpoint } from './endpointUtils';
import isEmpty from 'lodash/isEmpty';
import store from '../store';
import { MessageType } from '../constants/createSegment';
import { SESSION_TIMED_OUT } from '../constants/messages';
import { getEnvironmentStage, getStageSpecificCognitoAuthSettings } from './envUtils';
import { SHOW_NOTIFICATON } from '../actions/notificationActionsType';

export default async function apiRequest(url, params, sessionIdToken) {
  const endpoint = buildEndpoint(url);
  const storage = window['sessionStorage'];
  const token = isEmpty(sessionIdToken) ? storage.getItem('idToken') : sessionIdToken;

  const response = await fetch(endpoint, {
    ...params,
    mode: 'cors',
    headers: {
      ...params?.headers,
      Authorization: token,
    },
  });
  responseInterceptor(response);

  return response;
}

function responseInterceptor(response) {
  if (response?.status === 401 || response?.data?.message === '401 Unauthorized') {
    store.dispatch({
      type: SHOW_NOTIFICATON,
      payload: {
        message: SESSION_TIMED_OUT,
        timeout: 10000,
        type: MessageType.ERROR,
      },
    });
    setTimeout(() => {
      window.location.replace(
        getStageSpecificCognitoAuthSettings(getEnvironmentStage())?.RedirectUriSignIn,
      );
    }, 5000);
  }
}

export async function apiRequestWithoutInterceptor(url, params, sessionIdToken) {
  const endpoint = buildEndpoint(url);
  const storage = window['sessionStorage'];
  const token = isEmpty(sessionIdToken) ? storage.getItem('idToken') : sessionIdToken;

  return await fetch(endpoint, {
    ...params,
    mode: 'cors',
    headers: {
      ...params?.headers,
      Authorization: token,
    },
  });
}
